import { createClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_PUBLIC_SUPABASE_URL as string | undefined;
const supabaseAnonKey = import.meta.env.VITE_PUBLIC_SUPABASE_ANON_KEY as string | undefined;

// Whether valid Supabase credentials are actually configured.
export const isSupabaseConfigured = Boolean(supabaseUrl && supabaseAnonKey);

// Timeout-protected fetch so auth requests never hang forever. A hanging request
// is one of the common causes of the "Failed to fetch" refresh-token error.
const fetchWithTimeout: typeof fetch = (input, init) => {
  const controller = new AbortController();
  const timer = setTimeout(() => controller.abort(), 15000);
  return fetch(input, { ...init, signal: controller.signal }).finally(() =>
    clearTimeout(timer),
  );
};

export const supabase = createClient(
  supabaseUrl || 'https://placeholder.supabase.co',
  supabaseAnonKey || 'placeholder-key',
  {
    auth: {
      persistSession: true,
      // autoRefreshToken is intentionally disabled. When enabled, the client
      // silently tries to refresh a stale persisted session on every page load,
      // which throws an unhandled "Failed to fetch" on public pages (home,
      // portfolio, etc.). Admin routes refresh the session explicitly instead.
      autoRefreshToken: false,
      detectSessionInUrl: true,
      flowType: 'pkce',
    },
    global: {
      fetch: fetchWithTimeout,
    },
  },
);